import './App.css';
import Chart from './Chart';

function App() {
  return (
    <div className="App">
      {/* <header id="chart"> */}
        <Chart />
      {/* </header> */}
    </div>
  );
}

export default App;
